import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid-x" }
const _hoisted_2 = { class: "cell small-12 large-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "meetings-short-description" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "body-text-lg text-w-black title" }, " Want to follow up on your projects, learn more about Augmentify or just have a virtual coffee? "),
  /*#__PURE__*/_createElementVNode("p", { class: "body-text" }, " Schedule a meeting with one of our Talent Sorcerers or Account Managers and we’ll be happy to jump on a virtual call with you. ")
], -1)
const _hoisted_4 = { class: "cell small-12 large-9 x3large-8" }

import CalendlyEmbed from "@/components/client/CalendlyEmbed.vue";
import SideBanner from "@/components/utils/SideBanner.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'MeetingsView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(SideBanner, {
          "banner-img": "image-meetings.png",
          "banner-text": "Meetings"
        }, {
          "short-description": _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(CalendlyEmbed)
      ])
    ])
  ]))
}
}

})